export default "__VITE_ASSET__380333ca__"